import React from "react";
import Style from "../styles/text.module.scss";
const TitleH2Component = (props) => {
    return (
        <h4 className={`${Style.h2} ${props.styleGroup}`}>{props.children}</h4>
    )
}
export default TitleH2Component;